// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1sWfW","dragIcon":"Choice_dragIcon__3COep","left":"Choice_left__2Yi1d","input":"Choice_input__1ETjw"};